export const educationData = [
    {
        id: 1,
        institution: ' Pune University',
        course: 'Bsc.Computer Science',
        startYear: '2016',
        endYear: '2020'
    },
    {
        id: 2,
        institution: 'Pune University',
        course: 'Msc.Computer Science',
        startYear: '2020',
        endYear: '2022'
    },
    {
        id: 3,
        institution: 'Masai School Bangalore',
        course: 'Fullstack Web-Development',
        startYear: '2021',
        endYear: 'July 2022'
    },
]